<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Configuración</p>
              <argon-button
                color="success"
                size="sm"
                class="ms-auto"
                @click="save"
                :disabled="isSaving"
              >
                Guardar
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información de la empresa</p>
            <div class="row">
              <div class="col-md-12">
                <label class="form-control-label">Nombre de la empresa</label>
                <argon-input type="text" v-model="form.company_name" placeholder="Ej: Mi Empresa" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">NIT</label>
                <argon-input type="text" v-model="form.nit" placeholder="Número de identificación tributaria" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">Descripción</label>
                <textarea
                  class="form-control"
                  v-model="form.description"
                  rows="3"
                  placeholder="Descripción o notas"
                ></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Correo electrónico</label>
                <argon-input type="email" v-model="form.email" placeholder="contacto@empresa.com" />
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Teléfono</label>
                <argon-input type="text" v-model="form.phone" placeholder="+57 300 123 4567" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="form.address" placeholder="Dirección física" />
              </div>

              <div class="col-md-12">
                <label class="form-control-label">TRM dólar (peso a dólar)</label>
                <argon-input
                  type="number"
                  v-model="form.dollar_rate"
                  min="0"
                  step="0.01"
                  placeholder="Cuántos pesos vale un dólar. Ej: 4000"
                />
                <p class="text-muted text-xs mb-0 mt-1">
                  Se usa para mostrar el precio en dólares (USD) en el catálogo público. Deja en 0 para ocultarlo.
                </p>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">ConEnvios (guías de envío)</p>
                <div class="d-flex align-items-center mb-3">
                  <label class="form-control-label mb-0">Activar integración</label>
                  <div class="form-check form-switch ms-3 mb-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.conenvios_enabled"
                    />
                    <label class="form-check-label">Activa</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Correo del API</label>
                    <argon-input
                      type="email"
                      v-model="form.conenvios_email"
                      placeholder="correo@empresa.com"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Clave del API</label>
                    <input
                      type="password"
                      class="form-control"
                      v-model="form.conenvios_password"
                      :placeholder="hasConenviosPassword ? '•••••••• (dejar igual para no cambiar)' : 'Clave del API de ConEnvios'"
                      autocomplete="new-password"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <div class="d-flex align-items-center">
                  <label class="form-control-label mb-0">Beneficios de tareas</label>
                  <div class="form-check form-switch ms-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.benefits_of_tasks"
                    />
                    <label class="form-check-label">Activar</label>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Logos (opcional)</p>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Ícono / Logo claro</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="image/*"
                      @change="onLogoLightChange"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Ícono / Logo oscuro</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="image/*"
                      @change="onLogoDarkChange"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <div class="d-flex align-items-center mb-3">
                  <p class="text-uppercase text-sm mb-0">Shopify</p>
                  <div class="form-check form-switch ms-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.shopify_active"
                    />
                    <label class="form-check-label">Activar</label>
                  </div>
                </div>
                <div v-if="form.shopify_active" class="row">
                  <div class="col-md-12">
                    <label class="form-control-label">Dominio de la tienda</label>
                    <argon-input
                      type="text"
                      v-model="form.shopify_domain"
                      placeholder="tienda.myshopify.com"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Client ID</label>
                    <argon-input
                      type="text"
                      v-model="form.shopify_client_id"
                      placeholder="Client ID"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Client Secret</label>
                    <argon-input
                      type="password"
                      v-model="form.shopify_client_secret"
                      placeholder="Client Secret"
                    />
                  </div>
                  <div class="col-md-12 d-flex align-items-center gap-3 mt-2">
                    <argon-button
                      color="info"
                      size="sm"
                      @click="generateShopifyToken"
                      :disabled="isGeneratingToken"
                    >
                      {{ isGeneratingToken ? 'Generando...' : 'Generar token' }}
                    </argon-button>
                    <span v-if="form.shopify_access_token" class="text-xs text-success">
                      <i class="fa fa-check-circle"></i> Token guardado
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Swal from "sweetalert2";

export default {
  name: "Settings",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      isSaving: false,
      form: {
        company_name: "",
        nit: "",
        description: "",
        email: "",
        phone: "",
        address: "",
        dollar_rate: 0,
        conenvios_enabled: false,
        conenvios_email: "",
        conenvios_password: "",
        benefits_of_tasks: false,
        shopify_active: false,
        shopify_domain: "",
        shopify_client_id: "",
        shopify_client_secret: "",
        shopify_access_token: "",
      },
      logoLightFile: null,
      logoDarkFile: null,
      hasConenviosPassword: false,
      isGeneratingToken: false,
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const response = await this.$store.dispatch("settings/get");
        const data = response.data;
        this.hasConenviosPassword = !!data.has_conenvios_password;
        this.form = {
          company_name: data.company_name || "",
          nit: data.nit || "",
          description: data.description || "",
          email: data.email || "",
          phone: data.phone || "",
          address: data.address || "",
          dollar_rate: data.dollar_rate ? Number(data.dollar_rate) : 0,
          conenvios_enabled: !!data.conenvios_enabled,
          conenvios_email: data.conenvios_email || "",
          conenvios_password: "",
          benefits_of_tasks: !!data.benefits_of_tasks,
          shopify_active: !!data.shopify_active,
          shopify_domain: data.shopify_domain || "",
          shopify_client_id: data.shopify_client_id || "",
          shopify_client_secret: data.shopify_client_secret || "",
          shopify_access_token: data.shopify_access_token || "",
        };
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
        await Swal.fire("Error", "Error al cargar la configuración", "error");
      }
    },
    onLogoLightChange(event) {
      this.logoLightFile = event.target.files?.[0] || null;
    },
    onLogoDarkChange(event) {
      this.logoDarkFile = event.target.files?.[0] || null;
    },
    async generateShopifyToken() {
      this.isGeneratingToken = true;
      try {
        const response = await this.$store.dispatch("settings/generateShopifyToken");
        this.form.shopify_access_token = response.data.access_token || "";
        await Swal.fire("Éxito", response.data.message || "Token generado correctamente", "success");
        this.loadSettings();
      } catch (error) {
        console.error("Error al generar token Shopify:", error);
        await Swal.fire(
          "Error",
          error?.data?.message || "Error al generar el token de Shopify",
          "error"
        );
      } finally {
        this.isGeneratingToken = false;
      }
    },
    async save() {
      this.isSaving = true;
      try {
        const formData = new FormData();
        formData.append("company_name", this.form.company_name);
        formData.append("nit", this.form.nit ?? "");
        formData.append("description", this.form.description);
        formData.append("email", this.form.email);
        formData.append("phone", this.form.phone);
        formData.append("address", this.form.address);
        formData.append("dollar_rate", this.form.dollar_rate ?? 0);
        formData.append("conenvios_enabled", this.form.conenvios_enabled ? "1" : "0");
        formData.append("conenvios_email", this.form.conenvios_email || "");
        if (this.form.conenvios_password) {
          formData.append("conenvios_password", this.form.conenvios_password);
        }
        formData.append("benefits_of_tasks", this.form.benefits_of_tasks ? "1" : "0");
        formData.append("shopify_active", this.form.shopify_active ? "1" : "0");
        formData.append("shopify_domain", this.form.shopify_domain || "");
        formData.append("shopify_client_id", this.form.shopify_client_id || "");
        formData.append("shopify_client_secret", this.form.shopify_client_secret || "");
        if (this.logoLightFile) {
          formData.append("logo_path", this.logoLightFile);
        }
        if (this.logoDarkFile) {
          formData.append("logo_path_dark", this.logoDarkFile);
        }

        await this.$store.dispatch("settings/save", formData);
        await Swal.fire("Éxito", "Configuración guardada correctamente", "success");
        this.logoLightFile = null;
        this.logoDarkFile = null;
        this.form.conenvios_password = "";
        if (formData.get("conenvios_password")) {
          this.hasConenviosPassword = true;
        }
        document.querySelectorAll('input[type="file"]').forEach((el) => (el.value = ""));
      } catch (error) {
        console.error("Error al guardar:", error);
        await Swal.fire(
          "Error",
          error?.response?.data?.message || "Error al guardar la configuración",
          "error"
        );
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
